const conditions = require('./flow/conditions')
const partnerEnv = require('./config/partner')
const loaderSettings = require('./config/loader')
const flowSettings = require('./config/settings')
const flowVariants = require('./config/variants')

let config = {
  ...partnerEnv,
  loader: loaderSettings,
  settings: flowSettings,
  variants: flowVariants,
  // testScreen: 'city',
  path: (i18n) => ([
    {
      path: '/chapter1',
      params: {
        title: () => i18n.t('overview:step_one')
      },
      screens: [
        {
          type: 'email',
          params: {
            collectBlackbox: true
          }
        },
        {
          type: 'GDPR.startFlow',
          params: {
            conditions: [
              {
                property: 'app.showGDPRonFirstScreen', value: true
              }
            ]
          }
        }
      ]
    },
    {
      path: '/chapter2',
      params: {
        title: () => i18n.t('overview:step_two')
      },
      screens: [
        {
          type: 'password-animated',
          params: {
            checkBlackBoxInIovation: true,
            conditions: [
              {
                property: 'socialMediaData.socialSignIn',
                value: false
              }
            ]
          }
        },
        { type: 'phone-number' },
        { type: 'email-validation', params: { validation: true } }
      ]
    },
    {
      path: '/chapter3',
      params: {
        title: () => i18n.t('overview:step_three'),
        noTitleScreens: ['document-uploader']
      },
      screens: [
        {
          type: 'full-name',
          flowConfirmation: {
            groupId: 'name',
            orderNo: 1,
            labelLocale: () => i18n.t('fullName:full_name')
          }
        },
        {
          type: 'question.gender',
          params: {
            columns: true,
            text: () => i18n.t('gender:select_gender'),
            dispatchKey: 'updateUser',
            propertyName: 'gender',
            currentAnswer: (store) => store.state.user.gender,
            answers: () => ([
              { id: 'female', label: i18n.t('gender:female') },
              { id: 'male', label: i18n.t('gender:male') }
            ])
          }
        },
        {
          type: 'postal-code'
        },
        {
          type: 'question.state',
          params: {
            list: true,
            scrollShadow: true,
            text: () => i18n.t('postalCode:select_province', { context: 'us' }),
            dispatchKey: 'updateUser',
            propertyName: 'province',
            currentAnswer: (store) => store.state.user.state,
            answers: (store) => {
              return store.state.app.country.provinces.map(p => ({
                id: p.ISOCode.slice(-2),
                label: p.name
              }))
            },
            conditions: [
              {
                property: 'user.province',
                value: false
              },
              {
                property: 'app.postalArea.streets',
                value: false
              },
              {
                property: 'app.country.code',
                value: 'US'
              }
            ]
          }
        },
        {
          type: 'city'
        },
        {
          type: 'street-name'
        },
        {
          type: 'house-number'
        },
        {
          type: 'masked-birthdate'
        },
        { type: 'currency-selector' },

        { type: 'phone-number-validation' },
        {
          type: 'question.receive-offers',
          params: {
            columns: true,
            text: () => i18n.t('GDPR:receive_offers'),
            description: () => i18n.t('GDPR:receive_offers_description'),
            dispatchKey: 'updateUser',
            propertyName: 'receiveOffers',
            secondaryStyling: true,
            currentAnswer: (store) => store.state.user.receiveOffers,
            selectAnswerHandler: (store, answer) => {
              store.dispatch('toggleGDPRoffers', answer)
            },
            answers: () => ([
              { id: false, label: i18n.t('GDPR:no_thanks') },
              { id: true, label: i18n.t('GDPR:yes_please') }
            ]),
            conditions: [
              {
                property: 'app.country.code',
                value: 'GB'
              }
            ]
          }
        },
        {
          type: 'GDPR.marketing.endFlow',
          params: {
            isMarketingConsent: true,
            conditions: [
              {
                property: 'user.receiveOffers',
                value: false
              },
              {
                property: 'app.country.code',
                value: 'GB'
              }
            ]
          }
        },
        {
          type: 'question.id-type',
          params: {
            list: true,
            scrollShadow: true,
            text: () => i18n.t('specifics:idType.select'),
            dispatchKey: 'updateUser',
            propertyName: 'idType',
            currentAnswer: (store) => store.state.user.idType,
            answers: (store) => ([
              { id: 'national_id', label: i18n.t('specifics:idType.idCard') },
              { id: 'passport', label: i18n.t('specifics:idType.passport') },
              { id: 'driver_license', label: i18n.t('specifics:idType.driverLicense') }
            ]),
            conditions: [
              {
                property: 'app.manualVerificationFlow',
                value: true
              }
            ]
          }
        },
        {
          type: 'document-uploader',
          hideTitle: true,
          params: {
            header: () => i18n.t('specifics:documentUploader.header'),
            infoImage: require('static/uploader-info.svg'),
            buttonText: (store) => i18n.t('specifics:documentUploader.upload'),
            dispatchKey: 'updateUser',
            propertyName: 'uploadedDocumentURL',
            conditions: [
              {
                property: 'app.manualVerificationFlow',
                value: true
              }
            ]
          }
        },
        {
          type: 'GDPR.endFlow'
        },
        {
          type: 'sms-code',
          params: {
            conditions: conditions.otpFlow,
            associatedPhoneNumberUrl: '/chapter3/phone-number-validation'
          }
        }
      ]
    }
  ])
}

module.exports = config



// WEBPACK FOOTER //
// ./src/partners/partner.module.config.js